var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.containerClass},[_c('router-link',{class:_vm.iconClass,attrs:{"to":{ name: 'racewaybooking.checkout' }}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.visibleCartItemsCount),expression:"visibleCartItemsCount"}],class:_vm.countClass},[_vm._v(_vm._s(_vm.visibleCartItemsCount))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }